module.exports = __webpack_public_path__ + "static/img/31.579fa475.png";